import { CustomerOrderAcceptanceRules } from '@src/containers/Dealer/CustomerOrderAcceptanceRules';
import type { CustomerOrderAcceptanceRulesPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerOrderAcceptanceRulesPanel({
  api,
  params,
}: LayoutPanelProps<CustomerOrderAcceptanceRulesPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-order-acceptance-rules-panel"
    >
      <CustomerOrderAcceptanceRules />
    </EntityAdminPanelShell>
  );
}
